import {FormControl, FormGroup} from '@angular/forms';
import {Activity} from '../models/crm/activity';

export abstract class ActivityForm {
  static getFormGroup(): FormGroup {
    return new FormGroup({
      recipientId: new FormControl(),
      subject: new FormControl(),
      message: new FormControl(),
      pinned: new FormControl(false),
      repeatFrequency: new FormControl(),
      occurringDate: new FormControl(),
      occurringTime: new FormControl(),
      alertTime: new FormControl(),
    });
  }

  static update(form: FormGroup, activity: Activity): void {
    form.patchValue({
      recipientId: activity.recipient?.id ?? null,
      subject: activity.subject,
      message: activity.message,
      pinned: activity.pinned,
      repeatFrequency: activity.repeatFrequency,
      occurringDate: activity.occurringDate,
      occurringTime: activity.occurringTime,
      alertTime: activity.alertTime,
    });
  }
}
